import React, { useState } from 'react';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';

interface StepContentProps {
    title: string;
    currentStep: number;
    totalSteps: number;
    progress?: number;
    children: React.ReactNode;
    infoTooltip?: {
        title: string;
        message: string;
    };
}

const StepContent: React.FC<StepContentProps> = ({
    title,
    currentStep,
    totalSteps,
    progress,
    children,
    infoTooltip
}) => {
    const progressPercentage = progress || ((currentStep / totalSteps) * 100);
    const { infoAlert } = useReactConfirmAlert();

    const handleInfoClick = () => {
        if (infoTooltip) {
            infoAlert({
                title: infoTooltip.title,
                message: infoTooltip.message
            });
        }
    };

    return (
        <div className="step-content">
            <div className="step-header">
                <div className="step-header-content">
                    <h2 className="">
                        {infoTooltip && (
                            <i 
                                className="fas fa-info-circle info-icon" 
                                onClick={handleInfoClick}
                                style={{ cursor: 'pointer' }}
                                title="Haz clic para más información"
                            ></i>
                        )}
                        {!infoTooltip && <i className="fas fa-info-circle"></i>}
                        {title}
                    </h2>
                    <span className="step-indicator">Paso {currentStep} de {totalSteps}</span>
                </div>
                
                <div className="progress-bar">
                    <div 
                        className="progress-fill" 
                        style={{ width: `${progressPercentage}%` }}
                    ></div>
                </div>
            </div>

            <div className="step-body">
                {children}
            </div>
        </div>
    );
};

export default StepContent;
